// Albanian (Shqip) — answering-page strings only. Guests answering a survey in Albanian see the
// navigation and validation chrome in their language; everything outside the answering flow falls
// back to English (fallbackLng). Extend as needed.
export default {
    "You can select up to {count} options": "Mund të zgjidhni deri në {count} opsione",
    "Please answer all required questions to continue": "Ju lutemi përgjigjuni të gjitha pyetjeve të detyrueshme për të vazhduar",
    "Next Section": "Seksioni tjetër",
    "Previous Section": "Seksioni i mëparshëm",
    "Next Question": "Pyetja tjetër",
    "Previous Question": "Pyetja e mëparshme",
    "Complete": "Përfundo",
    "Please enter all field properly": "Ju lutemi plotësoni saktë të gjitha fushat",
    "This question is required": "Kjo pyetje është e detyrueshme",
    "Choose": "Zgjidhni",
    "Other option": "Opsion tjetër",
    "Read more": "Lexo më shumë",
    "Show less": "Shfaq më pak",
    "Loading": "Duke u ngarkuar",
};
